import { Device } from "./Device";
import { IpAddress, IpVersion } from "./IpAddress";
import { MacAddress } from "./MacAddress";
import { IfEntry } from "../InfoSets/IfTable";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { Dictionary } from "../Utils/Dictionary";

//export interface FdbEntryJson{
//	bridge_port_index: string;
//	mac_address: string;
//	status: string;
//}

export class FdbEntry {
	//public static FromJson(json: FdbEntryJson) {
	//	var mac = MacAddress.CreateFromString(json.mac_address);
 //       var result = new FdbEntry(mac);

 //       if (json.status !== undefined)
 //           result.Status = parseInt(json.status);
 //       if (json.bridge_port_index !== undefined)
 //           result.BpIndex = parseInt(json.bridge_port_index);

	//	return result;
	//}

	public MacAddress: MacAddress
	public get HasMacAddress(): boolean {
		return this.MacAddress && !this.MacAddress.IsNull;
	}

	public BpIndex: number;
	public get HasBpIndex(): boolean {
		return this.BpIndex >= 0;
	}

	public Status: number;
	public get HasStatus(): boolean {
		return this.Status >= 0;
	}

	public RemoteDevice: Device;
	public get HasRemoteDevice(): boolean {
		return this.RemoteDevice != null;
	}

	public get RemoteIpAddress(): IpAddress {
		if (this.RemoteDevice && this.RemoteDevice.HasIpAddress)
			return this.RemoteDevice.IpAddress;

		return IpAddress.CreateByVersion(IpVersion.IPv4);
	}

	public RemoteIfEntry: IfEntry;

	private CachedRemoteVendorName: string;
	private get HasCachedRemoteVendorName(): boolean {
		return !!this.CachedRemoteVendorName;
	}

	public get RemoteVendorName(): string {
		return this.CachedRemoteVendorName;
	}

	constructor(macAddress?: MacAddress) {
		this.MacAddress = macAddress;
		this.BpIndex = -1; // unset
		this.Status = -1; // unset

		this.RemoteDevice = null;
		this.RemoteIfEntry = null;
		this.CachedRemoteVendorName = '';
	}

	public Clone(cloneMac: MacAddress = null): FdbEntry {
		var cloneEntry: FdbEntry = null;

		if (cloneMac != null)
			cloneEntry = new FdbEntry(cloneMac.Clone());
		else
			cloneEntry = new FdbEntry(this.MacAddress);

		cloneEntry.BpIndex = this.BpIndex;
		cloneEntry.Status = this.Status;

		return cloneEntry;
	}
}

export class FdbTable {
	private _fdbTable: Dictionary<MacAddress, FdbEntry>;

	constructor() {
		this._fdbTable = new Dictionary<MacAddress, FdbEntry>();
	}

	public Add(macAddress: MacAddress, bpIndex: number): FdbEntry {
		var fdbEntry: FdbEntry = this._fdbTable.Item(macAddress);

		if (!fdbEntry) {
			fdbEntry = new FdbEntry(macAddress);
			this._fdbTable.Add(macAddress, fdbEntry);
		}

		fdbEntry.BpIndex = bpIndex;
		return (fdbEntry);
	}

	public AddEntry(fdbEntry: FdbEntry) {
		this._fdbTable.Add(fdbEntry.MacAddress, fdbEntry);
	}

	public Remove(macAddress: MacAddress, bpIndex: number): boolean {
		var fdbEntry: FdbEntry = this._fdbTable.Item(macAddress);

		if (fdbEntry && fdbEntry.BpIndex === bpIndex) {
			return this._fdbTable.Remove(macAddress);
		}

		return false;
	}

	public Clear(): void {
		this._fdbTable.Clear();
	}

	public get Count(): number {
		return (this._fdbTable.Count);
	}

	public Find(macAddress: MacAddress): FdbEntry {
		return this._fdbTable.Item(macAddress);
	}

	public FindByDevice(device: Device): FdbEntry {
		var fdbEntry: FdbEntry = null;
		this._fdbTable.Some((pair) => {
			if (pair.Value.HasRemoteDevice && ObjUtils.Equals(pair.Value.RemoteDevice, device)) {
				fdbEntry = pair.Value;
				return true;
			}
		});

		return (fdbEntry);
	}

	public RemoveEntry(fdbEntry: FdbEntry): void {
		this._fdbTable.Remove(fdbEntry.MacAddress);
	}

	public ClearRemoteCache(): void {
		this._fdbTable.ForEach((pair) => {
			pair.Value.RemoteDevice = null;
			pair.Value.RemoteIfEntry = null;
		});
	}

	public ForEach(callbackfn: (value: FdbEntry, index: number, array: FdbEntry[]) => void, thisArg?: any): void {
		this._fdbTable.Values().ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: FdbEntry, index: number, array: FdbEntry[]) => boolean, thisArg?: any): boolean {
		return this._fdbTable.Values().Some(callbackfn, thisArg);
	}
}
